import Base from './Base';
import { USER_ROLES } from '../modules/user';

export default class AccessRequest extends Base {
    get fullName() {
        if (this.user.full_name) {
            return this.user.full_name;
        }

        let fullName = '';
        if (this.user.first_name) {
            fullName += this.user.first_name;
        }

        if (this.user.last_name) {
            if (this.user.first_name) {
                fullName += ` ${this.user.last_name}`;
            } else {
                fullName += this.user.last_name;
            }
        }

        return fullName;
    }

    get countInboxes() {
        if (typeof this.member_teams_count !== 'number') {
            return 0;
        }

        return this.member_teams_count;
    }

    get hasStatusRequestedInboxAccess() {
        return this.request_type === 2;
    }

    get hasChangeRoleRequest() {
        return this.request_type === 1;
    }

    get hasInviteRequest() {
        return this.request_type === 3;
    }

    get statusLabel() {
        if (this.hasStatusRequestedInboxAccess) {
            return 'Requested Inbox Access';
        } else if (this.hasChangeRoleRequest) {
            return 'Requested Permissions Update';
        } else if (this.hasInviteRequest) {
            return 'Requested Access to Salesmsg';
        }

        return this.countInboxes === 1
            ? `${this.countInboxes} inbox`
            : `${this.countInboxes} inboxes`;
    }

    get color() {
        const palette = [
            '#6372A5',
            '#1D95F2',
            '#10D0AD',
            '#E13466',
            '#FFC422',
            '#FF9423',
            '#A233E1',
        ];

        return palette[this.id % palette.length];
    }

    get isUserAvatar() {
        return Boolean(this.user.photo_url);
    }

    get isDefaultUserAvatar() {
        if (!this.user.photo_url) {
            return false;
        }

        return this.user.photo_url.includes(`${window.location.hostname}/images/app/default-avatar.png`);
    }

    get userRoleClass() {
        return this.user.role === 'owner' ? 'is-primary' : this.withoutUserRoleClass();
    }

    withoutUserRoleClass() {
        return this.hasInviteRequest ? 'tag-info without-role' : 'tag-info';
    }

    get isOwnerUserRole() {
        return this.user.role === 'owner';
    }

    get isViewOnlyUserRole() {
        return this.user.role === USER_ROLES.VIEW_ONLY;
    }

    get isMemberUserRole() {
        return this.user.role === USER_ROLES.MEMBER;
    }

    get isManagerUserRole() {
        return this.user.role === USER_ROLES.MANAGER;
    }

    get isAdminUserRole() {
        return this.user.role === USER_ROLES.ADMIN;
    }

    get userRoleLabel() {
        if (this.isViewOnlyUserRole) {
            return 'Observer';
        }

        if (this.isMemberUserRole) {
            return 'Member';
        }

        if (this.isManagerUserRole) {
            return 'Manager';
        }

        if (this.isAdminUserRole) {
            return 'Admin';
        }

        if (this.hasInviteRequest) {
            return '-';
        }

        return 'Owner';
    }
}
